export default __webpack_public_path__ + "static/media/mike.b33ba0f1.jpg";